/* ============================================================
   spn-machine-search.js — 検索ページ（/search）の機種検索
   移植元: assets/machines.js searchMachines / initialGroupOf / syncSearchFilters / renderSearchResults
   変更点: スマスロ・スマパチのみ。種類は ?machine_type=（Shopify の ?type= と衝突させない）。
          商品の検索結果は Shopify（Liquid）側が出すので、ここは機種だけを描画する。
   前提: spn-machines-data.js → spn-machine-core.js の後に読み込む
   ============================================================ */
(function () {
  "use strict";
  var M = window.SPN_MACHINES;
  var target = document.querySelector("[data-render='machine-search-results']");
  if (!M || !target) return;
  var esc = M.escapeHtml;
  var PAGE_SIZE = 60;
  var MIN_PRICE = window.SPN_UNIT_MIN_PRICE || {};
  var LINE_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2C6.5 2 2 5.7 2 10.2c0 2.7 1.6 5.1 4.1 6.6l-.5 2c-.1.4.3.7.6.5 0 0 2.6-1.6 3.4-2.1.8.1 1.5.2 2.4.2 5.5 0 10-3.7 10-8.2S17.5 2 12 2z"/></svg>';

  var params = new URLSearchParams(location.search);
  var q = (params.get("q") || "").trim();
  var initial = (params.get("initial") || "").trim();
  var typeFilter = (params.get("machine_type") || "").trim();
  if (typeFilter !== "smaslo" && typeFilter !== "smapachi") typeFilter = "";
  var makerFilter = (params.get("m") || "").trim();

  // ---- 見本と同じ検索・頭文字判定 -------------------------------------------
  // 空白・全角半角・記号（・ : - など）の違いを無視して比べる（2026-10-14: 「モンキーターン V」等がヒットしない対策）
  function compact(s) {
    return String(s || "").normalize("NFKC").toLowerCase().replace(/[\s・:：\-‐－ー~〜!！?？'’"”.,、。]/g, function (c) { return c === "ー" ? "ー" : ""; });
  }
  function searchMachines(query) {
    var forms = M.buildQueryForms(query);
    if (!forms.length) return [];
    var cforms = forms.map(compact).filter(Boolean);
    return M.getEnabled().filter(function (m) {
      var idx = m.search_index || (m.name + " " + M.makerName(m.maker)).toLowerCase();
      if (forms.some(function (f) { return idx.indexOf(f) !== -1; })) return true;
      var cidx = compact(idx);
      return cforms.some(function (f) { return cidx.indexOf(f) !== -1; });
    });
  }
  var INITIAL_GROUPS = {
    "あ": /^[あいうえおぁぃぅぇぉアイウエオァィゥェォ]/,
    "か": /^[かきくけこがぎぐげごカキクケコガギグゲゴヵヶ]/,
    "さ": /^[さしすせそざじずぜぞサシスセソザジズゼゾ]/,
    "た": /^[たちつてとだぢづでどっタチツテトダヂヅデドッ]/,
    "な": /^[なにぬねのナニヌネノ]/,
    "は": /^[はひふへほばびぶべぼぱぴぷぺぽハヒフヘホバビブベボパピプペポ]/,
    "ま": /^[まみむめもマミムメモ]/,
    "や": /^[やゆよゃゅょヤユヨャュョ]/,
    "ら": /^[らりるれろラリルレロ]/,
    "わ": /^[わをんゎワヲンヮ]/
  };
  var INITIAL_STRIP_RE = /^(スマスロ|Lパチスロ|L パチスロ|パチスロ|LB|L|スマート沖スロ|e |P )\s*/;
  function initialGroupOf(name) {
    var s = (name || "").replace(INITIAL_STRIP_RE, "").trim();
    if (!s) return "その他";
    if (/^[A-Za-z]/.test(s)) return "alpha";
    if (/^[0-9]/.test(s)) return "numeric";
    for (var k in INITIAL_GROUPS) if (INITIAL_GROUPS[k].test(s)) return k;
    return "その他";
  }
  var byType = function (m) { return !typeFilter || m.machine_type === typeFilter; };

  function searchUrl(overrides) {
    var p = new URLSearchParams(location.search);
    Object.keys(overrides).forEach(function (k) {
      if (overrides[k] == null || overrides[k] === "") p.delete(k); else p.set(k, overrides[k]);
    });
    p.delete("page");
    var qs = p.toString();
    return "/search" + (qs ? "?" + qs : "");
  }

  // タブ・頭文字ボタン（Liquid が出した HTML）のリンク先と選択状態を合わせる
  document.querySelectorAll("[data-type-tabs] .type-tab").forEach(function (t) {
    var dt = t.getAttribute("data-type");
    t.setAttribute("href", searchUrl({ machine_type: dt === "all" ? "" : dt, m: "" }));
    t.classList.toggle("is-active", (!typeFilter && dt === "all") || dt === typeFilter);
  });
  document.querySelectorAll("[data-initial-grid] .initial-btn").forEach(function (b) {
    var di = b.getAttribute("data-initial");
    b.setAttribute("href", searchUrl({ initial: di, q: "", m: "" }));
    b.classList.toggle("is-active", di === initial);
  });

  function cardHtml(m) {
    var price = MIN_PRICE[m.machine_type];
    return '<a class="machine-card" href="' + M.machineUrl(m.slug) + '">' + M.thumbHtml(m, "machine-thumb-card") +
      '<div class="mc-body"><div class="mc-maker">' + esc(M.makerName(m.maker)) + '</div><div class="mc-name">' + esc(m.name) + "</div>" +
      (price ? '<div class="mc-price-from">対応商品 ¥' + Number(price).toLocaleString("ja-JP") + "〜</div>" : "") + "</div></a>";
  }
  var batch = [];
  function listHtml(list) {
    batch = list.slice(PAGE_SIZE);
    return '<div class="machine-card-list" data-machine-grid style="margin-top: 20px;">' + list.slice(0, PAGE_SIZE).map(cardHtml).join("") + "</div>" +
      (batch.length ? '<button type="button" class="btn-load-more" data-load-more><span class="lm-text">もっと見る</span><span class="lm-count">残り <strong>' + batch.length + "</strong> 件</span></button>" : "");
  }
  function bindLoadMore() {
    var btn = target.querySelector("[data-load-more]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      target.querySelector("[data-machine-grid]").insertAdjacentHTML("beforeend", batch.slice(0, PAGE_SIZE).map(cardHtml).join(""));
      batch = batch.slice(PAGE_SIZE);
      if (!batch.length) btn.remove(); else btn.querySelector(".lm-count strong").textContent = batch.length;
    });
  }
  var typeSuffix = typeFilter ? "（" + M.TYPE_LABEL[typeFilter] + "のみ）" : "";

  function render() {
    // 頭文字
    if (initial && (initial === "alpha" || initial === "numeric" || INITIAL_GROUPS[initial])) {
      var label = initial === "alpha" ? "A-Z で始まる機種" : initial === "numeric" ? "0-9 で始まる機種" : "「" + initial + "」行で始まる機種";
      var list = M.getEnabled().filter(function (m) { return initialGroupOf(m.name) === initial && byType(m); })
        .sort(function (a, b) { return M.machineSortKey(a).localeCompare(M.machineSortKey(b), "ja"); });
      target.innerHTML = '<div class="result-count">' + esc(label + typeSuffix) + "：<strong>" + list.length + "</strong> 機種</div>" +
        (list.length ? listHtml(list) : '<p style="margin-top:20px;color:var(--text-mute);">該当する機種がありません。<a href="' + searchUrl({ initial: "" }) + '">頭文字選択を解除</a> ／ <a href="/pages/maker-list">メーカーから探す</a></p>');
      bindLoadMore();
      return;
    }
    // 検索語なし
    if (!q) {
      if (typeFilter) {
        var all = M.getEnabled().filter(byType).sort(function (a, b) { return M.machineSortKey(a).localeCompare(M.machineSortKey(b), "ja"); });
        target.innerHTML = '<div class="result-count">' + esc(M.TYPE_LABEL[typeFilter]) + " 機種：<strong>" + all.length + "</strong> 機種</div>" + listHtml(all);
        bindLoadMore();
        return;
      }
      target.innerHTML = '<div class="search-prompt"><p style="text-align:center;color:var(--text-mute);padding:24px 0;font-size:15px;">機種名を入力するか、頭文字から探してください。</p></div>' +
        '<div class="section-head" style="margin-top:24px;"><h2 style="font-size:16px;">人気の機種</h2></div>' +
        '<div class="machine-card-list">' + M.popularMachines(null, 8).map(M.cardHtml).join("") + "</div>";
      return;
    }
    // 検索語あり
    var raw = searchMachines(q);
    var typed = raw.filter(byType);
    var results = makerFilter ? typed.filter(function (m) { return m.maker === makerFilter; }) : typed;
    var html = '<div class="result-count">機種の検索結果：<strong>「' + esc(q) + "」</strong>に該当する <strong>" + results.length + "</strong> 機種" +
      (typeFilter ? '<span style="color:var(--text-mute);font-size:14px;margin-left:8px;">（' + esc(M.TYPE_LABEL[typeFilter]) + "のみ表示・全体 " + raw.length + " 機種）</span>" : "") + "</div>";
    var counts = {};
    typed.forEach(function (m) { counts[m.maker] = (counts[m.maker] || 0) + 1; });
    var makerKeys = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    if (typed.length >= 2 && makerKeys.length >= 2) {
      html += '<div class="maker-chip-row"><a class="maker-chip' + (!makerFilter ? " is-active" : "") + '" href="' + searchUrl({ m: "" }) + '">すべて（' + typed.length + "）</a>" +
        makerKeys.map(function (mk) {
          return '<a class="maker-chip' + (mk === makerFilter ? " is-active" : "") + '" href="' + searchUrl({ m: mk }) + '">' + esc(M.makerName(mk)) + "（" + counts[mk] + "）</a>";
        }).join("") + "</div>";
    }
    var groups = {};
    results.forEach(function (m) { var k = m.name.replace(/[\s　]/g, "").toLowerCase(); groups[k] = (groups[k] || 0) + 1; });
    if (Object.keys(groups).some(function (k) { return groups[k] >= 2; })) {
      html += '<div class="same-name-caution"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"/><path d="M12 9v4M12 17v.01"/></svg>' +
        "<span>同じ名前の機種でも、年代・型番によって配線が異なる場合があります。お手元の機械の側面の型番シールをご確認ください。</span></div>";
    }
    if (results.length) {
      html += listHtml(results);
    } else {
      html += '<div class="search-empty-actions" style="margin-top: 20px;"><div class="search-empty-suggest">' +
        '<h3 style="font-size:16px;margin-bottom:12px;">機種名のスペルや表記を変えてみる</h3>' +
        '<ul style="color:var(--text-mute);font-size:15px;line-height:1.8;padding-left:20px;margin-bottom:18px;">' +
        "<li>「スマスロ」「L」などの接頭辞を外す（例：北斗の拳 / 化物語）</li><li>カタカナ ↔ ひらがな / 英数字を変えてみる</li><li>シリーズ名のみで検索（例：「リゼロ」「モンキー」）</li></ul>" +
        '<div style="display:flex;gap:10px;flex-wrap:wrap;"><a href="/pages/maker-list" class="btn-machine-secondary" style="display:inline-block;">メーカーから探す →</a></div></div>' +
        '<div style="margin-top: 28px;"><h3 style="font-size:16px;margin-bottom:12px;">こちらも探されています（人気機種）</h3>' +
        '<div class="machine-card-list">' + M.popularMachines(null, 4).map(M.cardHtml).join("") + "</div></div></div>";
    }
    html += '<div class="line-empty-card" style="margin-top: 32px;"><span class="icon-frame">' + LINE_SVG.replace('width="18" height="18"', 'width="28" height="28"') + "</span>";
    if (!results.length) {
      html += "<h3>機種名がうろ覚え・読み方が分からない方へ</h3><p>お持ちの機種の写真を LINE でお送りください。当店スタッフが無料で機種をお調べして、そのままご案内します。</p>" +
        '<div class="line-photo-tips"><strong>お送りいただきたい写真</strong><ul><li>筐体上部のロゴ部分</li><li>型番シール（機械側面に貼られていることが多いです）</li><li>リール部分（リールに描かれた絵柄）</li></ul><small>※ 1 枚でも、お送りいただければスタッフが判別いたします。</small></div>';
    } else {
      html += "<h3>探し方に迷ったら</h3><p>該当機種が見つからない、対応ユニットを選びきれない場合は LINE で機種名をお送りください。<br>スタッフがお調べしてご返信します。</p>";
    }
    html += '<a class="btn-line" data-line="' + (results.length ? "search" : "search-empty") + '" data-search-query="' + esc(q) + '">' + LINE_SVG + (results.length ? "機種名を LINE で聞いてみる" : "写真を LINE で送る") + "</a>" +
      '<small class="hours">スタッフが平日 10:00–17:00 にお返事します</small></div>';
    target.innerHTML = html;
    bindLoadMore();
  }

  render();
  if (window.LINE && typeof window.LINE.rebind === "function") window.LINE.rebind();
})();
